/**
 * Information Submitted Component
 * Based on Figma: https://www.figma.com/design/8nBzg5I71TF3EWyr6NcpVa/Fiat?node-id=4021-78813
 */
import { CircleCheck } from 'lucide-react';

import { Button } from '@components/ui/button';

interface InformationSubmittedProps {
  /**
   * Callback when "Return to deposits" button is clicked
   */
  onReturnToDeposits: () => void;
}

export function InformationSubmitted({
  onReturnToDeposits,
}: InformationSubmittedProps) {
  return (
    <div className="pt-5 sm:w-[394px]">
      {/* Content Section */}
      <div className="flex flex-col gap-6">
        {/* Text Content */}
        <div className="flex flex-col gap-3">
          {/* Success Icon with Concentric Circles */}
          <CircleCheck className="size-6" />
          <h2 className="text-foreground">Information submitted</h2>
          <p className="text-muted-foreground text-body-paragraph1">
            We are reviewing your details and will notify you once verification
            is complete. In the meantime, you can continue using other available
            deposit methods.
          </p>
        </div>
      </div>

      {/* Action Button */}
      <div className="mt-6 flex">
        <Button
          type="button"
          variant="primary"
          onClick={onReturnToDeposits}
          className="flex-1"
        >
          Return to deposits
        </Button>
      </div>
    </div>
  );
}
